import { createFileRoute, Outlet } from '@tanstack/react-router';
import { memo } from 'react';

export const Route = createFileRoute('/_neutral')({
  component: memo(NeutralLayout),
  beforeLoad: () => {
    // do nothing
  },
});

function NeutralLayout() {
  return <Outlet />;
}
